import React, { useEffect, useState } from 'react'
import { Link, useParams } from 'react-router-dom'
import imagePath from '../../constants/imagePath'
import StickyBox from "react-sticky-box";
import LatestNews from '../../Components/LatestNews';
import { useSelector } from 'react-redux';
import DOMPurify from "dompurify";
import moment from 'moment';
import parse, { domToReact } from "html-react-parser";
import { getNewsPost } from '../../redux/actions/settings';



function NewsInsightsDetail() {
    const { slug } = useParams();
    const { selectedNews } = useSelector((state: any) => state.settings)
    const [loading, setLoading] = useState(false)
    const [newsData, setNewsData] = useState(selectedNews)
    const isMobile = window.innerWidth <= 991;

    useEffect(() => {
        const url = `/${slug}`
        setLoading(true)
        getNewsPost(url).then((res) => {
            setLoading(false)
            setNewsData(res?.data)
        }).catch((error: any) => {
            setLoading(false)
        })
    }, [])


    useEffect(() => {
        const sections = document.querySelectorAll("h2[id], h3[id]");
        const navItems = document.querySelectorAll(
            ".intro_pt[data-id], .sub_intr_pt[data-id]"
        );

        const observer = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                        const id = entry.target.id;

                        navItems.forEach((item) => {
                            item.classList.remove("active_txt");

                            if (item.getAttribute("data-id") === id) {
                                item.classList.add("active_txt");
                            }
                        });
                    }
                });
            },
            {
                rootMargin: "-40% 0px -50% 0px",
                threshold: 0
            }
        );

        sections.forEach((section) => observer.observe(section));

        return () => observer.disconnect();
    }, []);


    return (
        <>
            <section className="hero_sec newsbg" style={{ backgroundImage: `url(${newsData.featuredImageUrl})` }}>
                <div className="contair ">
                    <div className="hero_l">
                        {/* <div className="bread">
                            <Link to='/news-insights'>News & Insights  </Link> <span>/ {newsData?.slug}</span>
                        </div> */}
                        <div className="hero_heading">
                            <h1>{newsData?.title}</h1>
                        </div>
                        <h4>{moment(newsData?.created_at).format('MMMM DD , YYYY')}  </h4>
                    </div>
                </div>
            </section>
            {parse(newsData?.content || "", {
                replace: (domNode: any) => {
                    if (domNode.name === "stickybox") {
                        return isMobile ? (
                            <>{domToReact(domNode.children)}</>   // render normal content
                        ) : (
                            <StickyBox offsetTop={100} offsetBottom={20} className="sticky_cls">
                                {domToReact(domNode.children)}
                            </StickyBox>
                        );
                    }
                },
            })}


            {/* <LatestNews /> */}
        </>
    )
}

export default NewsInsightsDetail